export enum ProcessStatus {
  Processed = 'PROCESSED',
  Processing = 'PROCESSING',
  Aborted = 'ABORTED',
  Abort = 'ABORT'
}
